<template>
  <div>
    <div class="view-header">
      <h1 class="is-size-5 is-expanded">
        Service {{ $route.params.id ? "Edit" : "Add" }}
      </h1>
    </div>
    <div class="box">
      <div class="columns" v-if="role !== 'engineer'">
        <div class="column">
          <engineer-select v-model="service.engineer"></engineer-select>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <input-select
            label="Service Type"
            v-model="service.serviceType"
            :valid="serviceTypeValid"
            required
          >
            <option value="installation">Installation</option>
            <option value="breakdown">Breakdown</option>
            <option value="maintenance">Maintenance</option>
          </input-select>
        </div>
        <div class="column">
          <input-select
            label="Visit Type"
            v-model="service.visitType"
            :valid="visitTypeValid"
            required
          >
            <option value="warranty">Warranty</option>
            <option value="contract">Contract</option>
            <option value="free">Free</option>
            <option value="chargeable">Chargeable</option>
          </input-select>
        </div>
        <div class="column">
          <input-select
            label="Status"
            v-model="service.status"
            :valid="statusValid"
            required
          >
            <option value="pending">Pending</option>
            <option value="completed">Completed</option>
          </input-select>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <input-field
            label="Customer Name"
            type="text"
            v-model="service.customerName"
            :valid="customerNameValid"
            required
          ></input-field>
        </div>
        <div class="column">
          <input-field
            label="Contact Person"
            type="text"
            v-model="service.contactPerson"
            :valid="contactPersonValid"
          ></input-field>
        </div>
        <div class="column">
          <input-field
            label="Contact Number"
            type="tel"
            v-model="service.contactNumber"
            :valid="contactNumberValid"
            required
          ></input-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <input-field
            label="Principals"
            v-model="service.principals"
            :valid="principalsValid"
            required
          ></input-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <input-field
            label="Instrument"
            type="text"
            v-model="service.instrument"
            :valid="instrumentValid"
            required
          ></input-field>
        </div>
        <div class="column">
          <input-field
            label="Model Number"
            type="text"
            v-model="service.modelNumber"
            :valid="modelNumberValid"
          ></input-field>
        </div>
        <div class="column">
          <input-field
            label="Serial Number"
            type="text"
            v-model="service.serialNumber"
            :valid="serialNumberValid"
          ></input-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <input-field
            label="Visit Date"
            type="date"
            v-model="service.visitedAt"
            :valid="visitedAtValid"
            required
          ></input-field>
        </div>
        <div class="column">
          <input-field
            label="Warranty From"
            type="date"
            v-model="service.warrantyStart"
            :valid="warrantyStartValid"
          ></input-field>
        </div>
        <div class="column">
          <input-field
            label="Warranty To"
            type="date"
            v-model="service.warrantyEnd"
            :valid="warrantyEndValid"
          ></input-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <input-field
            label="Complaint"
            type="text"
            v-model="service.complaint"
            :valid="complaintValid"
            required
          ></input-field>
        </div>
      </div>
      <div class="columns">
        <div class="column">
          <input-field
            label="Quotations"
            type="text"
            v-model="service.quotations"
            :valid="quotationsValid"
            required
          ></input-field>
        </div>
      </div>
      <input-text
        label="Observations"
        v-model="service.observations"
        :valid="observationsValid"
        required
      ></input-text>
      <input-text
        label="Work Done"
        v-model="service.workDone"
        :valid="workDoneValid"
        optional
      ></input-text>
      <input-text
        label="Customer Comments"
        v-model="service.customerComments"
        :valid="customerCommentsValid"
        optional
      ></input-text>
      <hr />
      <attachments
        :service="service"
        @add="onAttachmentAdd"
        @remove="onAttachmentRemove"
      ></attachments>
      <p class="has-text-center has-text-danger">{{ errorMessage }}</p>
      <hr />
      <div class="is-flex">
        <div class="is-expanded">
          <button class="button is-borderless" @click="onCancelClicked">
            Cancel
          </button>
        </div>
        <div class="is-expanded has-text-right">
          <button
            class="button is-primary"
            :class="{ 'is-loading': loading }"
            :disabled="!formValid || loading"
            @click="onSaveClicked"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import moment from "moment"
import validator from "validator"
import EngineerSelect from "../../components/engineer-select"
import Attachments from "./components/attachments"
export default {
  components: { EngineerSelect, Attachments },
  data() {
    return {
      service: {
        visitedAt: "",
        customerName: "",
        contactPerson: "",
        contactNumber: "",
        principals: "",
        instrument: "",
        modelNumber: "",
        serialNumber: "",
        serviceType: "",
        complaint: "",
        observations: "",
        workDone: "",
        customerComments: "",
        status: "",
        quotations: "",
        attachment: "",
        engineer: "",
        visitType: "",
        warrantyStart: "",
        warrantyEnd: "",
        attachments: []
      },
      loading: false,
      errorMessage: ""
    }
  },
  methods: {
    onCancelClicked() {
      let component = this
      component.$router.go(-1)
    },
    onSaveClicked() {
      let component = this
      component.loading = true
      component.$store
        .dispatch(
          component.service._id ? "service/update" : "service/store",
          component.service
        )
        .then((response) => {
          component.$router.push(
            `/request/service/view/${response.data.serviceRequest._id}`
          )
        })
        .catch((error) => {
          console.log("fail")
          if (
            error.response.status === 500 &&
            error.response.data.error.code === 11000
          ) {
            component.errorMessage = error.response.data.error.errmsg
          }
        })
    },
    onAttachmentAdd(attachment) {
      this.service.attachments.push(attachment)
    },
    onAttachmentRemove(attachment) {
      this.service.attachments.splice(
        this.service.attachments.indexOf(attachment),
        1
      )
    }
  },
  computed: {
    role() {
      return localStorage.getItem("role")
    },
    engineerValid() {
      let component = this
      return component.service.engineer._id !== undefined
    },
    serviceTypeValid() {
      let component = this
      return component.service.serviceType !== ""
    },
    visitTypeValid() {
      let component = this
      return component.service.visitType !== ""
    },
    statusValid() {
      let component = this
      return component.service.status !== ""
    },
    customerNameValid() {
      let component = this
      return component.service.customerName !== ""
    },
    contactPersonValid() {
      let component = this
      return component.service.contactPerson === ""
        ? true
        : component.service.contactPerson.length > 3
    },
    contactNumberValid() {
      let component = this
      return (
        component.service.contactNumber !== "" &&
        validator.isMobilePhone(component.service.contactNumber)
      )
    },
    instrumentValid() {
      let component = this
      return component.service.instrument !== ""
    },
    modelNumberValid() {
      let component = this
      let regex = /^[0-9a-zA-Z]+$/
      return component.service.modelNumber === ""
        ? true
        : regex.test(component.service.modelNumber)
    },
    serialNumberValid() {
      let component = this
      let regex = /^[0-9a-zA-Z]+$/
      return component.service.serialNumber === ""
        ? true
        : regex.test(component.service.serialNumber)
    },
    quotationsValid() {
      let component = this
      return component.service.quotations !== ""
    },
    visitedAtValid() {
      let component = this
      return moment(component.service.visitedAt).isValid()
    },
    warrantyStartValid() {
      let component = this
      return component.service.warrantyStart === ""
        ? true
        : moment(component.service.warrantyStart).isValid()
    },
    warrantyEndValid() {
      let component = this
      return component.service.warrantyEnd === ""
        ? true
        : moment(component.service.warrantyEnd).isValid()
    },
    principalsValid() {
      let component = this
      return component.service.principals !== ""
    },
    complaintValid() {
      let component = this
      return component.service.complaint !== ""
    },
    observationsValid() {
      let component = this
      return component.service.observations !== ""
    },
    workDoneValid() {
      return this.service.workDone !== ""
        ? this.service.workDone.length < 1024
        : true
    },
    customerCommentsValid() {
      return this.service.customerComments !== ""
        ? this.service.customerComments.length < 1024
        : true
    },
    formValid() {
      let component = this
      let validationRules = [
        component.engineerValid,
        component.serviceTypeValid,
        component.visitTypeValid,
        component.statusValid,
        component.customerNameValid,
        component.contactPersonValid,
        component.contactNumberValid,
        component.instrumentValid,
        component.modelNumberValid,
        component.serialNumberValid,
        component.quotationsValid,
        component.warrantyStartValid,
        component.warrantyEndValid,
        component.principalsValid,
        component.observationsValid
      ]
      for (let i = 0; i < validationRules.length; i++) {
        if (!validationRules[i]) {
          return false
        }
      }
      return true
    }
  },
  mounted() {
    let component = this
    component.loading = true
    if (component.$route.params.id) {
      component.$store
        .dispatch("service/show", component.$route.params.id)
        .then((response) => {
          response.data.password = ""
          response.data.contactPerson = response.data.contactPerson || ""
          response.data.workDone = response.data.workDone || ""
          response.data.customerComments = response.data.customerComments || ""
          response.data.attachments = response.data.attachments || []
          response.data.warrantyStart = response.data.warrantyStart || ""
          response.data.warrantyEnd = response.data.warrantyEnd || ""
          component.service = response.data
          component.loading = false
        })
        .catch((error) => {
          console.log(error)
          component.loading = false
        })
    } else {
      if (component.role === "engineer") {
        component.service.engineer = { _id: localStorage.getItem("user") }
      }
      component.loading = false
    }
  }
}
</script>
